export const scrollToTop = () => {
    let top = document.getElementById('al-top');
    
    if (top && top.scrollIntoView) {
        top.scrollIntoView();
    }
};
